import React from 'react';
import { motion } from 'framer-motion';
import { Info } from 'lucide-react';
export function DidYouKnow() {
  return <section className="w-full py-16 px-4" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-forest text-cream-card p-8 md:p-10 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-70">
          {/* Decorative background elements */}
          <div className="absolute -right-10 -top-10 opacity-10" data-id="element-71">
            <Info className="w-48 h-48" data-id="element-72" />
          </div>

          <h2 className="font-handwriting text-4xl font-bold mb-8 text-center relative z-10" data-id="element-73">
            Wusstest du das?
          </h2>

          <ul className="space-y-6 font-serif text-lg relative z-10" data-id="element-74">
            <li className="flex items-start gap-4" data-id="element-75">
              <div className="w-2 h-2 rounded-full bg-cream mt-2.5 flex-shrink-0" data-id="element-76" />
              <p data-id="element-77">
                Ein gesunder Hund verdaut innerhalb von{' '}
                <strong data-id="element-78">8-10 Stunden</strong>.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-79">
              <div className="w-2 h-2 rounded-full bg-cream mt-2.5 flex-shrink-0" data-id="element-80" />
              <p data-id="element-81">
                <strong data-id="element-82">Ballaststoffmangel</strong> ist einer der häufigsten
                Gründe für eine träge Verdauung beim Hund.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-83">
              <div className="w-2 h-2 rounded-full bg-cream mt-2.5 flex-shrink-0" data-id="element-84" />
              <p data-id="element-85">
                Lösliche Ballaststoffe können die Darmpassagezeit um{' '}
                <strong data-id="element-86">bis zu 40% verbessern</strong>.
              </p>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}